import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MemberService } from 'src/app/services/member.service';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';
import { HomeService } from 'src/app/services/home.service';
import { AdminService } from 'src/app/services/admin.service';
import { PrivilegeService } from 'src/app/services/privilege.service';
import { Message } from 'src/app/models/privilege';
import { catchError, switchMap } from 'rxjs/operators';
import { of, Subscription } from 'rxjs';
import { adminSetting } from 'src/app/models/walai';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  IsPrivilege: boolean = false;
  passwordFieldType: string = 'password';

  constructor(
    private fb: UntypedFormBuilder,
    private route: Router,
    private activateRoute: ActivatedRoute,
    private memberService: MemberService,
    private translate: TranslateService,
    private data: DataService,
    private homeService: HomeService,
    private adminService: AdminService,
    private _privilege: PrivilegeService,
    private configService: ConfigService
  ) {
    this.adminService.getLogoBanner('logo').subscribe(async (data: any) => {
      this.logo = data;
    });

    this.adminService
      .GetOpacConfigValue('Sitename')
      .subscribe(async (data: any) => {
        if (data.includes('SRU Library')) {
          this.userLogin = 'MemberID';
        }
      });

    if (this.configService.siteName == 'CMRU') {
      this.userLogin = 'Username';
    }

    if (this.configService.siteName == 'BUU') {
      this.userLogin = 'Username';
    }
  }

  loginForm: UntypedFormGroup;
  login: login;
  submitted = false;
  Onlogin = false;
  logo = '';
  redirectURL = null;

  userLogin = 'EmailAddressOrUsername';
  loginUBUSubcription: Subscription = new Subscription();
  sitename: string = '';
  pdpaUrl: string = 'assets/pdpa_moj.pdf';
  EmailContact: string = '';

  onSubmit() {
    this.submitted = true;
  }

  ngOnInit(): void {
    if (this.configService.siteName == 'MOJ') {
      this.adminService
        .getGeneralPageSetting()
        .subscribe((setting: adminSetting[]) => {
          if (setting.length > 0)
            this.EmailContact = setting.find(
              (x) => x.PARAMETERKEY == 'EmailContact'
            ).VALUE;
        });
    }

    try {
      this.redirectURL = this.activateRoute.snapshot.queryParamMap.get('redirectURL');
    } catch (error) {
      this.redirectURL = null;
    }

    if (this.redirectURL != null) {
      this.redirectURL = decodeURIComponent(this.redirectURL);
    }

    this.loadForm();
  }

  // ประกาดตัวแปร Form และภายใน Form
  loadForm() {
    this.loginForm = this.fb.group({
      username: new UntypedFormControl('', [Validators.required]),
      password: new UntypedFormControl('', Validators.required),
    });
  }

  // กำหนดค่าให้แก่ ตัวแปร Username + Password
  prepareData() {
    this.login = new login();
    this.login.username = this.loginForm.controls.username.value;
    this.login.password = this.loginForm.controls.password.value;
  }

  // กดปุ่ม Submit
  clickLogin() {
    this.Onlogin = true;
    this.prepareData();

    switch (this.configService.siteName) {
      case 'UBU':
        this.loginUBU();
        break;
      default:
        this.loginWalai(false);
        break;
    }
  }

  loginUBU() {
    this.loginUBUSubcription = this.memberService
      .userUBULogin(this.login)
      .pipe(
        switchMap(async (res: any) => {
          switch (res.status) {
            case 200:
              if (res.body.result == true) {
                this.loginWalai(false);
              } else {
                this.loginWalai(true);
              }

              break;
            default:
              // reject(false);
              this.errorMsg();
              break;
          }
        }),
        catchError((e) => {
          //   reject(false);
          this.errorMsg();
          return of([]);
        })
      )
      .subscribe();
  }

  loginWalai(dbWalai: boolean) {
    this.memberService.userLogin(this.login, dbWalai).subscribe(
      (getData: any) => {
        if (getData) {
          if (getData.length > 0) {
            if (getData[0].LOCKED == 1) {
              this.ErrorlogIn(
                this.translate.instant('This username has locked!')
              );
              return;
            } else {
              if (getData[0].USERSTATUS == 2 || getData[0].USERSTATUS == 4) {
                if (getData[0].USERSTATUS == 2) {
                  this.ErrorlogIn(
                    this.translate.instant('This username has expired!')
                  );

                  setTimeout(() => {
                    this.redirectToMain(getData);
                  }, 1000);
                }
                if (getData[0].USERSTATUS == 4) {
                  this.ErrorlogIn(
                    this.translate.instant('This username is retired!')
                  );
                }

                return;
              } else {
                this.redirectToMain(getData);

                return;
              }
            }
          } else {
            this.errorMsg();
          }
        } else {
          this.errorMsg();
        }
      },
      (error) => {
        this.errorMsg();
      }
    );
  }

  errorMsg() {
    this.ErrorlogIn(
      this.translate.instant('Invalid email, username or password, please try again!')
    );
  }

  redirectToMain(getData: any) {
    this.Onlogin = false;
    localStorage.setItem('WALAIcurrentUser', JSON.stringify(getData));
    this.data.updateMemberImg(getData[0].PATHPIC);
    this.data.updateMemberAccount(getData);

    if (this.redirectURL != null) {
      window.location.href = this.redirectURL;
    } else {
      
    this.route.navigateByUrl('/member');
    }
  }

  ErrorlogIn(msg: string) {
    this.Onlogin = false;
    Swal.fire({
      position: 'top-end',
      icon: 'error',
      title: msg,
      showConfirmButton: false,
      timer: 1500,
    });
  }

  help() {
    let help = '';
    this.homeService.getParameter('loginHelp').subscribe((VALUE: any) => {
      if (VALUE.length == 1) {
        help = VALUE[0].VALUE;

        Swal.fire({
          title: '<strong>' + this.translate.instant('login') + '</strong>',
          icon: 'info',
          html: help,
          showCloseButton: false,
          showCancelButton: false,
          focusConfirm: false,
        });
      }
    });
  }

  CloseMember() {
    Swal.fire({
      icon: 'warning',
      title: 'Oops...',
      text: 'ระบบสมาชิก ไม่พร้อมให้บริการ!',
      showConfirmButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      //timer: 30000
    }).then((result) => {
      if (result.isConfirmed) {
        this.route.navigateByUrl('/home');
      }
    });
  }

  ngOnDestroy(): void {
    if (this.loginUBUSubcription) {
      this.loginUBUSubcription.unsubscribe();
    }
  }

  togglePasswordVisibility(): void {
    this.passwordFieldType =
      this.passwordFieldType === 'password' ? 'text' : 'password';
  }
}

export class login {
  public username: string;
  public password: string;
}
